import { useEffect, useState } from "react";
import { db } from "../firebase";
import { resolveModelInterestCatalog } from "../utils/modelInterest";

export const useModelInterestCatalog = (storedOptions) => {
  const hasStoredOptions = storedOptions !== undefined;
  const [catalog, setCatalog] = useState(() =>
    resolveModelInterestCatalog(hasStoredOptions ? storedOptions : null),
  );

  useEffect(() => {
    if (hasStoredOptions) {
      setCatalog(resolveModelInterestCatalog(storedOptions));
      return undefined;
    }

    let cancelled = false;
    db.collection("settings")
      .doc("current")
      .get()
      .then((docRef) => {
        if (!cancelled) {
          setCatalog(
            resolveModelInterestCatalog(docRef.data()?.modelInterestOptions),
          );
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCatalog(resolveModelInterestCatalog(null));
        }
      });

    return () => {
      cancelled = true;
    };
  }, [hasStoredOptions, storedOptions]);

  return catalog;
};
